import { Muted } from '@/components/sv/typographies'

const EmptySummaryItem = ({ label }: { label: string }) => (
  <div className="flex-1 min-w-0 px-6 py-4">
    <Muted className="text-xs">{label}</Muted>
    <p className="mt-1 text-xl font-semibold text-muted-foreground">N/A</p>
  </div>
)

const Divider = () => <div className="w-px bg-border" />

export const EmptySummaryCards = () => (
  <div className="flex">
    <EmptySummaryItem label="Current period" />
    <Divider />
    <EmptySummaryItem label="Projected total" />
    <Divider />
    <EmptySummaryItem label="Previous period" />
    <Divider />
    <EmptySummaryItem label="Change" />
  </div>
)
